export type LoginError = {
  detail: string,
  code?: string
}

export type Credentials = {
  access?: string,
  refresh?: string
}
export const ROLE = {
  ADMIN: 'ADMIN',
  USER: 'USER',
  TECHNICIAN: 'TECHNICIAN'
};